"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_WIDTH = 300;

var Bullet = function Bullet(_ref) {
  var variant = _ref.variant,
      color = _ref.color;

  if (variant === 'themes') {
    return /*#__PURE__*/_react.default.createElement("rect", {
      x: 0,
      y: 8,
      width: 10,
      height: 4,
      rx: 2,
      ry: 2,
      fill: color
    });
  }

  return /*#__PURE__*/_react.default.createElement("circle", {
    r: 4,
    cx: 4,
    cy: 10,
    fill: color
  });
};

var Item = (0, _styledComponents.withTheme)(function (_ref2) {
  var text = _ref2.text,
      variant = _ref2.variant,
      color = _ref2.color,
      y = _ref2.y,
      theme = _ref2.theme,
      inverted = _ref2.inverted;
  return /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(0,".concat(y, ")")
  }, /*#__PURE__*/_react.default.createElement(Bullet, {
    variant: variant,
    color: color
  }), /*#__PURE__*/_react.default.createElement("text", {
    x: 16,
    y: 14,
    fontFamily: theme.font1,
    fontWeight: "500",
    fontSize: 13,
    fill: inverted ? theme.inverted.one[0] : theme.one[0]
  }, text));
});

var Legend = function Legend(_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme,
      groups = _ref3.groups,
      themes = _ref3.themes,
      colorScale = _ref3.colorScale,
      inverted = _ref3.inverted,
      background = _ref3.background;
  var bg;

  if (background) {
    var bgColor = inverted ? theme.inverted.two[0] : theme.two[0];
    bg = /*#__PURE__*/_react.default.createElement("rect", {
      width: "100%",
      height: "100%",
      fill: bgColor
    });
  }

  var itemProps, height;

  if (variant === 'themes') {
    height = themes.length * 21 - 8;
    itemProps = themes.map(function (theme) {
      return {
        id: theme.themeId,
        text: theme.name
      };
    });
  } else {
    height = groups.length * 21 - 8;
    itemProps = groups.map(function (group) {
      return {
        id: group.groupId,
        text: group.name
      };
    });
  }

  return /*#__PURE__*/_react.default.createElement("svg", {
    height: height,
    width: MAX_WIDTH
  }, bg, itemProps.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      variant: variant,
      inverted: inverted,
      key: item.id,
      text: item.text,
      color: colorScale(item.id),
      y: i * 21 - 4
    });
  }));
};

Legend.propTypes = {
  variant: _propTypes.default.oneOf(['groups', 'themes']),
  inverted: _propTypes.default.bool,
  background: _propTypes.default.bool,
  groups: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    groupId: _propTypes.default.string.isRequired
  })).isRequired,
  colorScale: _propTypes.default.func.isRequired
};
Legend.defaultProps = {
  variant: 'groups'
};

var _default = (0, _styledComponents.withTheme)(Legend);

exports.default = _default;
//# sourceMappingURL=LegendSvg.js.map